const baseButtonSize = {
  small: {
    padding: '8px 16px'
  },
  medium: {
    padding: '12px 24px'
  },
  large: {
    padding: '16px 32px'
  }
};

const pressButtonSize = {
  small: {
    padding: '8px 15px'
  },
  medium: {
    padding: '10px 32px'
  },
  large: {
    padding: '14px 32px'
  }
};

const buttonSizes = {
  products: {
    chart: baseButtonSize,
    chartblog: baseButtonSize,
    co: baseButtonSize,
    edu: baseButtonSize,
    press: pressButtonSize,
    spark: baseButtonSize
  }
};

export default buttonSizes;
